<template>
  <div class="icon">
    <ul>
      <li>
        <a class="call" href="tel:0903745077" target="_blank">
          <img src="@/assets/img/icon1.svg" alt="전화문의"
        /></a>
      </li>
      <li>
        <a
          class="instargram"
          href="https://www.instagram.com/rice.cake.hcm/"
          target="_blank"
        >
          <img src="@/assets/img/icon3.svg" alt="인스타그램" />
        </a>
      </li>
      <li>
        <a
          class="kakao"
          href="http://qr.kakao.com/talk/IPaaewyCbKbsb8gtzCR_KPP_nyQ-"
          target="_blank"
        >
          <img src="@/assets/img/icon2.svg" alt="카카오톡" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Icon",
};
</script>

<style lang="scss" scoped>
@import "@/assets/utils/scss/fluid-typo.scss";
.icon {
  position: sticky;
  bottom: 0px;
  margin-top: 28px;
  background: rgba(#fff, 0.8);
  ul {
    list-style-type: none;
    margin: 0;
    display: flex;
    justify-content: center;
    padding: 10px 20px 28px;

    > * + * {
      margin-left: 30px;
    }

    li {
      width: 40px;
      height: 40px;
      overflow: hidden;
      margin-bottom: 5px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
